import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  phoneUtil: PhoneNumberUtil;

  constructor() {
    this.phoneUtil = PhoneNumberUtil.getInstance();
  }

  transform(phone: string): string {
    if (!phone) return '';

    try {
      return this.phoneUtil.format(
        this.phoneUtil.parseAndKeepRawInput(phone),
        PhoneNumberFormat.INTERNATIONAL
      );
    } catch (e) {
      console.warn(e);
      return phone;
    }
  }
}
